module.exports = __webpack_public_path__ + "img/collection-memoireRingsPlatinum.495ea0d.webp";